<template>
    <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 h-full overflow-hidden">
        <div class="
          pb-5
          border-b border-gray-200
          sm:flex
          sm:items-center
          sm:justify-between">
            <div class="sm:w-0 sm:flex-1">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Accept/Decline Case
                </h3>
            </div>
        </div>

        <div class="md:flex w-full" v-if="message != ''">
            <div class="w-full py-10 px-5">
                <div
                    class="message-box px-4 py-2 rounded text-gray-900 bg-green-500"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                    tabindex="-1"
                    ref="statusMessage"
                >
                    <span v-if="info.accept_decline!='accept'">{{ message }}</span>
                    <span v-if="info.accept_decline=='accept'"> {{ message }} <a href="https://attorney.uslegalservices.net/login" target="_blank" rel="noopener noreferrer" class="text-gray-900 underline font-bold visited:text-gray-900 hover:text-gray-900 focus:text-gray-900"><b><u>Attorney Portal</u></b></a> or email authorizations@uslegalservices.net.</span>
                </div>
            </div>
        </div>
        <div class="flex flex-col bg-white" v-if="message == ''">
            <div class="my-2 sm:-mx-6 lg:-mx-8 px-8">
                <div class="py-2 align-middle inline-block w-full sm:px-6 lg:px-8">
                    <div class="induty_opt" v-if="case_info.member_number != ''">
                        <div class="form-group">

                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Member:</div>
                                <div class="w-full sm:w-2/3">{{ case_info.first_name }} {{ case_info.last_name }}</div>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Member Number:</div>
                                <div class="w-full sm:w-2/3">#{{ case_info.member_number }}</div>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Phone:</div>
                                <div class="w-full sm:w-2/3">{{ case_info.phone }}</div>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Address:</div>
                                <div class="w-full sm:w-2/3">{{ case_info.address1 }} {{ case_info.city }} {{
            case_info.state }} {{
            case_info.zip }}</div>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Matter Number:</div>
                                <div class="w-full sm:w-2/3">#{{ case_info.matter_number }}</div>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Coverage:</div>
                                <div class="w-full sm:w-2/3">{{ case_info.coverage }}</div>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">Subcoverage:</div>
                                <div class="w-full sm:w-2/3">{{ case_info.attorney_sub_coverage || "-" }}</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="mb-4">
                                <h3 class="text-lg font-semibold">Note to Attorney:</h3>
                                <p class="font-bold">{{ case_info.note }}</p>
                                <p>{{ case_info.note_description }}</p>
                            </div>
                        </div>

                        <div class="form-group" v-if="case_info.matter_number">
                            <div class="flex flex-wrap mb-4">
                                <label class="ui-radio">
                                    <input
                                        type="radio"
                                        v-model="info.accept_decline"
                                        value="accept"
                                        @change="selectionError = ''"
                                    />
                                    <span> I accept this matter</span>
                                </label>
                                <br />
                                <label class="ui-radio ml-4">
                                    <input
                                        type="radio"
                                        v-model="info.accept_decline"
                                        value="decline"
                                        @change="selectionError = ''"
                                    />
                                    <span> I decline this matter</span>
                                </label>
                            </div>
                            <p v-if="selectionError" class="text-red-600 text-sm mb-4">
                                {{ selectionError }}
                            </p>
                        </div>

                        <div class="form-group" v-if="info.accept_decline === 'decline'">
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">
                                    <p>Please tell us why you are declining</p>
                                </div>
                                <div class="w-full sm:w-1/3">
                                    <select class="form-control w-full" v-model="info.note_from_attorney">
                                        <option value="Member Attorney conflict/Conflict of interest">
                                            Member Attorney conflict/Conflict of interest
                                        </option>
                                        <option value="Attorney declined fee schedule.">
                                            Attorney declined fee schedule.
                                        </option>
                                        <option value="Attorney does not handle case type.">
                                            Attorney does not handle case type.
                                        </option>
                                        <option value="Attorney does not practice in city/county.">
                                            Attorney does not practice in city/county.
                                        </option>
                                        <option value="Attorney no longer in practice.">
                                            Attorney no longer in practice.
                                        </option>
                                        <option value="No availability/Full case load.">
                                            No availability/Full case load.
                                        </option>
                                        <option value="Member unresponsive/Lack of communication.">
                                            Member unresponsive/Lack of communication.
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" v-if="info.accept_decline === 'decline'">
                            <div class="flex flex-wrap mb-4">
                                <div class="w-full sm:w-1/3 font-medium">
                                    <p>Did you have a consultation with the member?</p>
                                </div>
                                <div class="w-full sm:w-2/3">
                                    <label class="ui-radio">
                                        <input type="radio" v-model="info.had_consult" value="Yes" />
                                        <span> Yes</span>
                                    </label>
                                    <label class="ui-radio ml-4">
                                        <input type="radio" v-model="info.had_consult" value="No" />
                                        <span> No</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" v-if="case_info.matter_number">
                            <div class="flex justify-start mt-4">
                                <button
                                    type="button"
                                    class="btn bg-green-500 text-white py-2 px-4 rounded"
                                    @click="attorney_action()"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuthList",
    data() {
        return {
            message: "",
            case_info: {
                first_name: '',
                last_name: '',
                member_number: '',
                phone: '',
                address1: '',
                city: '',
                state: '',
                zip: '',
                matter_number: '',
                coverage: '',
                sub_coverage: '',
                note: '',
                note_description: '',
            },
            info: {
                accept_decline: '',
                note_from_attorney: '',
                had_consult: '',
            },
            selectionError: '',
        };
    },
    watch: {
        message(newVal) {
            if (!newVal) return;
            this.$nextTick(() => {
                if (this.$refs.statusMessage && this.$refs.statusMessage.focus) {
                    this.$refs.statusMessage.focus();
                }
            });
        },
    },
    mounted() {
        this.$store
            .dispatch("dataDecrypt", this.$route.params.data)
            .then((result) => {
                // console.log(result)
                if (result.status == 200) {
                    this.info = result.data;
                    this.$store
                        .dispatch("getToken")
                        .then((result1) => {
                            if (result1.data.status == "Active") {
                                this.get_case_details(result1.data.token);
                            } else {
                                this.$toast.error("Something went wrong, Please try again!");
                            }
                        })
                        .catch((error1) => {
                            this.$toast.error(error1);
                            this.$toast.error("Something went wrong, Please try again!");
                        });
                } else {
                    this.$toast.error("Something went wrong, Please try again!");
                }
            })
            .catch((error) => {
                console.log(error)

                this.$toast.error(error.message);
            });
    },
    methods: {
        get_case_details(token) {
            this.$store
                .dispatch("getCaseDetails", { matter_id: this.info.matter_id, token: token })
                .then((result) => {
                    if (result.data.status == "Success") {
                        if (
                            this.info.attorney_id === result.data.data.attorney_id &&
                            (result.data.data.status === 'Assigned To Attorney' || result.data.data.status === 'Authorized')
                        ) {
                            this.case_info = result.data.data;
                            console.log(this.case_info)
                        } else {
                            this.message = "We're sorry, this case has been reassigned to another attorney. If you have questions or need additional information, please contact Authorizations at 844-894-5297 or authorizations@uslegalservices.net.";
                        }
                    } else {
                        this.$toast.error("Something went wrong, Please try again!");
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error(error.message);
                });
        },
        attorney_action() {
            const action = this.info.accept_decline;
            if (action !== "accept" && action !== "decline") {
                this.selectionError =
                    "Please select either \"I accept this matter\" or \"I decline this matter\" before submitting.";
                this.$toast.error(this.selectionError);
                return false;
            }
            this.selectionError = "";

            if (action === "decline") {
                if (
                    this.info.note_from_attorney == "" ||
                    this.info.note_from_attorney == null
                ) {
                    this.$toast.error("Please enter reason for declining the case.");
                    return false;
                }
                if (this.info.had_consult !== "Yes" && this.info.had_consult !== "No") {
                    this.$toast.error(
                        "Please select whether you had a consultation with the member."
                    );
                    return false;
                }
            }

            this.$store
                .dispatch("CaseConfirmation", { action: action, info: this.info, case: this.case_info })
                .then((result) => {
                    if (result.data.status == "Success") {
                        if (this.info.accept_decline == "accept") {
                            this.message = "Thank you for accepting the case. The member is responsible for making initial contact with you. If additional legal services are needed past the initial consultation, please submit an Authorization Request through your "
                        } else {
                            this.message = "Thank you for your response that you will not accept this case. We will contact our member to provide reassignment to another attorney. If you have questions or need additional information, please contact Authorizations at 844-894-5297 or authorizations@uslegalservices.net.";
                        }

                    } else {
                        this.$toast.error("Something went wrong, Please try again!");
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error("Something went wrong, Please try again!");
                });
        },
    },
};
</script>

<style scoped>
/* Add your custom styles here */
</style>